module.exports = __webpack_public_path__ + "popup.7caf61b740bbaeb2cabe265c19d09c05.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/less/img/popup.jpg
// module id = 19
// module chunks = 0